/* eslint-disable camelcase */
import React from 'react';

import { RichText } from 'prismic-reactjs';
import { linkResolver } from '../../../../util/linkResolver';

import { StyledContent } from './ContentStyles';

const Content = blog_post_content => {
  // the following ugly code handles our need to reformat and return blog content with
  // old codeblock syntax turned into one styled preformatted block.
  // TODO: if we switch back to the other gatsby content API this code will need to revert to
  // the old method
  const newContent = [];
  let codeBlock = '';
  let startTracker = false;
  let endTracker = false;

  // loop through original content array
  for (let i = 0; i < blog_post_content.length; i += 1) {
    const obj = blog_post_content[i];

    // if indication of code '```[' but no closing indication

    if (obj && obj.text && obj.text.includes('```[') && !obj.text.includes('}```')) {
      startTracker = true;
      endTracker = false;
    } else if (obj && obj.text && obj.text.includes('`}```') && !obj.text.includes('```[')) {
      // else if there is a closing indication end the tracker
      endTracker = true;
      startTracker = false;
    }

    // if start of codeblock add current object text string up to codeBlock variable
    if (startTracker && !endTracker) {
      const text = obj.text.includes('```[') || obj.text.includes('`}```') ? '' : obj.text;
      codeBlock = `${codeBlock} ${text}`;
    } else if (!startTracker && endTracker) {
      // else if end of codeblock push codeBlock to newContent array as one preformatted obj
      newContent.push({
        type: 'preformatted',
        text: codeBlock.trim(),
        spans: Array(0),
      });
      // reset start and end to false as well as clear out codeBlock string
      startTracker = false;
      endTracker = false;
      codeBlock = '';
    } else if (obj.text && obj.text.includes('```[') && obj.text.includes('`}```')) {
      // else if the object includes open and closing remove old codeblock syntax and push up to array
      const text = obj.text && obj.text.replace(/```\[\w*\]\{`(.+?)`}```/g, '$1');
      newContent.push({
        type: 'preformatted',
        text: text.trim(),
        spans: Array(0),
      });
    } else {
      // else push up the object as is
      newContent.push(obj);
    }
  }

  return (
    <StyledContent>
      <RichText render={newContent} linkResolver={linkResolver} />
    </StyledContent>
  );
};

export default Content;
